<template>
  <div>
    <el-radio v-model="worldwide" :value="true" disabled>
      All countries
    </el-radio>
    <el-radio v-model="worldwide" disabled :value="false">
      Specific countries
    </el-radio>
    <el-transfer
      v-if="!worldwide"
      v-model="value"
      label-position="top"
      :titles="['1', 'Target countries']"
      :data="countries"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, computed, onMounted } from 'vue'
import { ICountry } from '@/api/countries'

import { useCountriesStore } from '@/store/modules/countries'
import useResize from '@/hooks/useResize'

type CountryEntry = {
  key: string
  label: string
  disabled: boolean
}

export default defineComponent({
  name: 'CountriesBlock',
  props: {
    modelValue: {
      type: Array,
      required: true
    }
  },
  setup(props, context) {
    const value = ref(props.modelValue)
    const countriesStore = useCountriesStore()

    countriesStore.GetItems()

    const worldwide = ref(props.modelValue.length === 0)
    const countries = computed(() => {
      const countries = countriesStore.sorted
      return countries
        .filter((country: ICountry) => country.attributes.iso !== 'un')
        .map<CountryEntry>((country: ICountry) => {
          return {
            key: country.attributes.iso,
            label: country.attributes.name,
            disabled: true
          }
        })
    })

    onMounted(() => {
      const transferPanels = document.getElementsByClassName(
        'el-transfer-panel'
      ) as HTMLCollectionOf<HTMLElement>
      if (transferPanels.length > 1) {
        transferPanels[0].style.display = 'none'
      }
    })

    const { isDesktop } = useResize()

    return { worldwide, value, countries, isDesktop }
  }
})
</script>

<style lang="scss" scoped>
:deep(.el-transfer__buttons) {
  display: none;
}

:deep(.el-transfer:first-child) {
  display: none;
}

:deep(.el-checkbox__input) {
  display: none;
}

:deep(.el-transfer-panel__header .el-checkbox__label > span) {
  display: none;
}
</style>
